var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import './new-slider.css';
import Carousel from 'react-elastic-carousel';
import { Subject } from 'rxjs';
import { useForceUpdate } from '../../lib/misc.functions';
import web1 from '../../assets/images/1x-banner.jpg';
import web2 from '../../assets/images/1x-banner-2.jpg';
import web3 from '../../assets/images/1x-banner-3.jpg';
import mslide1 from '../../assets/images/1x-mobil-banner.jpg';
import { sliderMap, sliderMapSubject } from "../../store/static.pages.store";
import i18n from "i18next";
export var eventSliderSubject = new Subject();
var WEB_SLIDES_STATIC = [web1, web2, web3];
var MOBILE_SLIDES_STATIC = [mslide1];
var BREAK_POINTS = [{ width: 1, itemsToShow: 1 }];
export default function NewSlider() {
    var _a;
    var forceUpdate = useForceUpdate();
    var activeLang = (_a = i18n.resolvedLanguage) !== null && _a !== void 0 ? _a : 'en';
    var currentSliders = sliderMap[activeLang] || [];
    useEffect(function () {
        var sub = sliderMapSubject.subscribe(function () {
            forceUpdate();
        });
        return function () { return sub.unsubscribe(); };
    }, [forceUpdate]);
    return (_jsxs("div", __assign({ className: "ns-wrapper" }, { children: [_jsx("div", __assign({ className: "ns-panel ns-panel-main" }, { children: _jsx(Carousel, __assign({ isRTL: false, enableAutoPlay: true, autoPlaySpeed: 5000, breakPoints: BREAK_POINTS, pagination: false, showArrows: false }, { children: WEB_SLIDES_STATIC.map(function (src, i) { return (_jsx("div", __assign({ className: "ns-slide" }, { children: _jsx("img", { src: src, alt: "", loading: i === 0 ? 'eager' : 'lazy' }, void 0) }), 'static_web_' + i)); }) }), void 0) }), void 0), _jsx("div", __assign({ className: "ns-panel ns-panel-side" }, { children: _jsx(Carousel, __assign({ isRTL: false, enableAutoPlay: true, autoPlaySpeed: 5000, breakPoints: BREAK_POINTS, pagination: false, showArrows: false }, { children: MOBILE_SLIDES_STATIC.map(function (src, i) { return (_jsx("div", __assign({ className: "ns-slide" }, { children: _jsx("img", { src: src, alt: "", loading: i === 0 ? 'eager' : 'lazy' }, void 0) }), 'static_mob_' + i)); }) }), void 0) }), void 0)] }), void 0));
}
